// Adapted from https://stackoverflow.com/questions/21575051/implementing-a-directive-to-exclude-a-hidden-input-element-from-validation-add

(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives').directive('tyShownValidation', function () {
            return {
                require: '^?form',
                restrict: 'A',
                link: function (scope, element, attrs, form) {
                    if (!form) {
                        return;
                    }

                    var control;

                    scope.$watch(element.closest("[data-ng-show]").attr("data-ng-show"), function (value) {

                        if (!control) {
                            control = form[element.attr("name")];
                        }
                        if (value === true) {
                            form.$addControl(control);

                            // manually update form validity
                            angular.forEach(control.$error, function (validity, validationToken) {
                                form.$setValidity(validationToken, !validity, control);
                            });
                        } else {
                            form.$removeControl(control);
                        }
                    });
                }
            };
        });
})(window.angular);